import {NavigationEntry} from '../routing.types';

const MAX_NAVIGATION_HISTORY_SIZE = 50;

function recordNavigation(
  navigationHistory: NavigationEntry[],
  url: string,
): NavigationEntry[] {
  const lastEntry = navigationHistory[navigationHistory.length - 1];

  if (lastEntry?.url === url) {
    return navigationHistory;
  }

  const updated = [...navigationHistory, {url, timestamp: Date.now()}];

  if (updated.length > MAX_NAVIGATION_HISTORY_SIZE) {
    return updated.slice(1);
  }

  return updated;
}

export default recordNavigation;
